window.jt_is_touch_device = function(){
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
    return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};


function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) {
      return;
    }

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}


// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}


function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}


/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.mainMediaDrawer = this.querySelector('.menu-drawer__media');
    this.resizeTimeOut = null;

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    window.addEventListener('resize', this.onResize.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    const summaries = this.querySelectorAll('summary');
    const buttons = this.querySelectorAll('button');

    summaries.forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    buttons.forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');

    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    let _this = this;

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const mediaDrawer = this.mainMediaDrawer;

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);

      if (mediaDrawer) {
        const submenu = detailsElement.querySelector('.menu-drawer__submenu');
        let winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (winWidth < 990) {
          const menuList = detailsElement.querySelector('.menu-drawer__menu');
          const menuCloseBtn = detailsElement.querySelector('.menu-drawer__close-button');
          const siteHeader = document.querySelector('#shopify-section-header .header-wrapper');
          const siteAnnouncement = document.getElementById('shopify-section-announcement-bar');

          let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
          let mediaHeight = winHeight - menuList.offsetHeight;

          if (siteHeader) {
            mediaHeight -= siteHeader.offsetHeight;
          }

          if (siteAnnouncement) {
            mediaHeight -= siteAnnouncement.offsetHeight;
          }

          if (menuCloseBtn) {
            mediaHeight -= menuCloseBtn.offsetHeight;
          }

          submenu.style.paddingBottom = '0px';
          mediaDrawer.style.minHeight = '0px';

          if (mediaHeight >= 180) {
            mediaDrawer.style.height = mediaHeight + 'px';
          } else {
            mediaDrawer.style.height = '0px';
          }
        } else {
          mediaDrawer.style.height = '';
          mediaDrawer.style.minHeight = '';
          submenu.style.paddingBottom = '';
        }
      }
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();

      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      const thisMainDetailsToggle = this.mainDetailsToggle;
      const mainDetailsParent = this.mainDetailsToggle.parentElement;

      if (isOpen && mainDetailsParent.classList.contains('menu-type--type_2')) {
        event.preventDefault();

        // close this drawer
        const submenu = detailsElement.querySelector('.menu-drawer__submenu');

        submenu.style.setProperty('height', '0px');

        const closestInnerSubmenu = detailsElement.closest('.menu-drawer__inner-submenu');
        let allSiblingDetailsHeight = 0;

        if (closestInnerSubmenu) {
          const allSiblingDetails = closestInnerSubmenu.querySelectorAll('details');

          if (allSiblingDetails.length) {
            let i = 0;
            
            allSiblingDetails.forEach((details) => {
              i++;
              allSiblingDetailsHeight += details.querySelector('summary').offsetHeight;

              if (i > 1 && i == allSiblingDetails.length) {
                let listItemStyle = window.getComputedStyle(details.parentElement);
                let listItemMargin = parseFloat(listItemStyle['marginBottom']);
                let listItemPadding = parseFloat(listItemStyle['paddingBottom']);
                
                allSiblingDetailsHeight += Math.ceil(listItemMargin + listItemPadding);
              }
            });
          }

          closestInnerSubmenu.parentElement.style.setProperty('height', allSiblingDetailsHeight +'px');
        }

        setTimeout(() => {
          detailsElement.classList.remove('menu-opening');
          detailsElement.removeAttribute('open');
          summaryElement.setAttribute('aria-expanded', false);
          parentMenuElement.classList.remove('submenu-open');
          submenu.style.removeProperty('height');
  
          const nestedDetails = detailsElement.querySelectorAll('details[open]');

          if (nestedDetails.length) {
            nestedDetails.forEach(details => {
              const nestedSubmenu = detailsElement.querySelector('.menu-drawer__submenu');

              nestedSubmenu.style.removeProperty('height');
              details.classList.remove('menu-opening');
              details.removeAttribute('open');
              details.querySelector('summary').setAttribute('aria-expanded', false);
    
              const openedSubmenu = details.querySelector('.submenu-open');
    
              if (openedSubmenu) {
                openedSubmenu.classList.remove('submenu-open');
              }
            });
          }
        }, 500);
      } else if (!isOpen && mainDetailsParent.classList.contains('menu-type--type_2')) {
        // close other drawers
        const allOpenedDetails = this.mainDetailsToggle.querySelectorAll('details[open]');
        const closestDetails = detailsElement.parentElement.closest('details');
        const submenu = detailsElement.querySelector('.menu-drawer__submenu');
        const closestInnerSubmenu = detailsElement.closest('.menu-drawer__inner-submenu');

        submenu.style.setProperty('height', '0px');

        let detailsContentHeight = 0;
        let siblingDetailsHeight = 0;

        if (allOpenedDetails.length) {
          allOpenedDetails.forEach(details => {
            if (details !== thisMainDetailsToggle && details !== detailsElement && details !== closestDetails) {
              const submenuDrawer = details.querySelector('.menu-drawer__submenu');
  
              submenuDrawer.style.setProperty('height', '0px');
  
              setTimeout(() => {
                details.classList.remove('menu-opening');
                details.removeAttribute('open');
                details.querySelector('summary').setAttribute('aria-expanded', false);
  
                const openedSubmenu = details.querySelector('.submenu-open');
  
                if (openedSubmenu) {
                  openedSubmenu.classList.remove('submenu-open');
                }
                
                submenuDrawer.style.removeProperty('height');
              }, 500);
            }
          });
        }

        /*if (closestInnerSubmenu) {
          closestInnerSubmenu.parentElement.style.setProperty('height', '0px');
        }*/

        setTimeout(() => {
          Array.from(submenu.children).forEach((child) => {
            if (child.classList.contains('menu-drawer__menu')) {
              let childStyles = window.getComputedStyle(child);
              let childMargins = parseFloat(childStyles['marginTop']) + parseFloat(childStyles['marginBottom']);

              detailsContentHeight = Math.ceil(child.offsetHeight + childMargins);
            } else if (child.classList.contains('menu-drawer__inner-submenu')) {
              const childMenu = child.querySelector('.menu-drawer__menu');
              let childStyles = window.getComputedStyle(childMenu);
              let childMargins = parseFloat(childStyles['marginTop']) + parseFloat(childStyles['marginBottom']);

              detailsContentHeight = Math.ceil(childMenu.offsetHeight + childMargins);
            }
          });

          if (closestInnerSubmenu) {
            const siblingDetails = closestInnerSubmenu.querySelectorAll('details');
  
            if (siblingDetails.length) {
              let j = 0;
              
              siblingDetails.forEach((details) => {
                j++;
                
                if (details !== detailsElement) {
                  siblingDetailsHeight += details.querySelector('summary').offsetHeight;
                }
  
                if (j > 1 && j == siblingDetails.length) {
                  let listItemStyle = window.getComputedStyle(details.parentElement);
                  let listItemMargin = parseFloat(listItemStyle['marginBottom']);
                  let listItemPadding = parseFloat(listItemStyle['paddingBottom']);
                  
                  siblingDetailsHeight += Math.ceil(listItemMargin + listItemPadding);
                }
              });
            }
          }
          
          detailsElement.classList.add('menu-opening');
          submenu.style.setProperty('height', detailsContentHeight +'px');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');

          if (closestInnerSubmenu) {
            closestInnerSubmenu.parentElement.style.setProperty(
              'height', 
              (detailsContentHeight + siblingDetailsHeight) + detailsElement.querySelector('summary').offsetHeight +'px'
            );
          }
        }, 100);
      }

      if (!mainDetailsParent.classList.contains('menu-type--type_2')) {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');

          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    let winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    
    this.mainDetailsToggle.classList.remove('menu-opening');

    const allDetails = this.mainDetailsToggle.querySelectorAll('details');

    allDetails.forEach(details => {
      if (!details.classList.contains('keep-open') && (winWidth < 750 || !details.classList.contains('mobile-facets__details'))) {
        details.classList.remove('menu-opening');
        details.removeAttribute('open');
      }
    });

    const allOpenedSubmenus = this.mainDetailsToggle.querySelectorAll('details:not(.keep-open) > .submenu-open:not(.keep-open)');

    allOpenedSubmenus.forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });

    const allSubmenus = this.mainDetailsToggle.querySelectorAll('.menu-drawer__submenu');

    allSubmenus.forEach(submenu => {
      submenu.style.removeProperty('height');
    });
    
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');

    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');

        const closestDetailsOpen = detailsElement.closest('details[open]');

        if (closestDetailsOpen) {
          const closestDetailsOpenSummary = detailsElement.querySelector('summary');

          trapFocus(closestDetailsOpen, closestDetailsOpenSummary);

          if (this.mainMediaDrawer) {
            const submenu = closestDetailsOpen.querySelector('.menu-drawer__submenu');
            let winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

            if (winWidth < 990) {
              const menuList = closestDetailsOpen.querySelector('.menu-drawer__menu');
              const menuCloseBtn = closestDetailsOpen.querySelector('.menu-drawer__close-button');
              const siteHeader = document.querySelector('#shopify-section-header .header-wrapper');
              const siteAnnouncement = document.getElementById('shopify-section-announcement-bar');

              let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
              let mediaHeight = winHeight - menuList.offsetHeight;
    
              if (siteHeader) {
                mediaHeight -= siteHeader.offsetHeight;
              }
    
              if (siteAnnouncement) {
                mediaHeight -= siteAnnouncement.offsetHeight;
              }

              if (menuCloseBtn) {
                mediaHeight -= menuCloseBtn.offsetHeight;
              }

              submenu.style.paddingBottom = '0px';
              this.mainMediaDrawer.style.minHeight = '0px';
              
              if (mediaHeight >= 180) {
                this.mainMediaDrawer.style.height = mediaHeight + 'px';
              } else {
                this.mainMediaDrawer.style.height = '0px';
              }
            } else {
              this.mainMediaDrawer.style.height = '';
              this.mainMediaDrawer.style.minHeight = '';
              submenu.style.paddingBottom = '';
            }
          }
        } else if (this.mainMediaDrawer) {
          const submenus = this.querySelectorAll('.menu-drawer__submenu');
          let winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

          if (winWidth < 990) {
            // set top menu height
            const menuList = this.querySelector('.menu-drawer__menu');
            const siteHeader = document.querySelector('#shopify-section-header .header-wrapper');
            const siteAnnouncement = document.getElementById('shopify-section-announcement-bar');
  
            let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            let mediaHeight = winHeight - menuList.offsetHeight;
  
            if (siteHeader) {
              mediaHeight -= siteHeader.offsetHeight;
            }
  
            if (siteAnnouncement) {
              mediaHeight -= siteAnnouncement.offsetHeight;
            }
            
            if (mediaHeight >= 180) {
              this.mainMediaDrawer.style.height = mediaHeight + 'px';
              this.mainMediaDrawer.style.minHeight = '0px';
            } else {
              this.mainMediaDrawer.style.height = '0px';
              this.mainMediaDrawer.style.minHeight = '0px';
            }
          } else {
            this.mainMediaDrawer.style.height = '';
            this.mainMediaDrawer.style.minHeight = '';
          }

          if (submenus && submenus.length) {
            submenus.forEach((submenu) => {
              submenu.style.paddingBottom = '';
            });
          }
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  onResize(event) {
    const context = this;
    
    if (this.mainMediaDrawer) {
      if (this.resizeTimeOut) {
        clearTimeout(this.resizeTimeOut);
      }
  
      this.resizeTimeOut = setTimeout(function() {
        const openedDetails = context.querySelectorAll('details[open]:not(.menu-drawer-container)');
        let winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  
        if (openedDetails && openedDetails.length) {
          const currentOpenedDetails = openedDetails[openedDetails.length - 1];
          const submenu = currentOpenedDetails.querySelector('.menu-drawer__submenu');
  
          if (winWidth < 990) {
            const siteHeader = document.querySelector('#shopify-section-header .header-wrapper');
            const siteAnnouncement = document.getElementById('shopify-section-announcement-bar');
            const menuList = currentOpenedDetails.querySelector('.menu-drawer__menu');
            const menuCloseBtn = currentOpenedDetails.querySelector('.menu-drawer__close-button');
            let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            
            let mediaHeight = winHeight - menuList.offsetHeight;
      
            if (siteHeader) {
              mediaHeight -= siteHeader.offsetHeight;
            }
      
            if (siteAnnouncement) {
              mediaHeight -= siteAnnouncement.offsetHeight;
            }
  
            if (menuCloseBtn) {
              mediaHeight -= menuCloseBtn.offsetHeight;
            }
  
            submenu.style.paddingBottom = '0px';
            context.mainMediaDrawer.style.minHeight = '0px';
                
            if (mediaHeight >= 180) {
              context.mainMediaDrawer.style.height = mediaHeight + 'px';
            } else {
              context.mainMediaDrawer.style.height = '0px';
            }
          } else {
            context.mainMediaDrawer.style.height = '';
            context.mainMediaDrawer.style.minHeight = '';
            submenu.style.paddingBottom = '';
          }
        } else {
          const submenus = context.querySelectorAll('.menu-drawer__submenu');
          
          if (winWidth < 990) {
            const menuList = context.querySelector('.menu-drawer__menu');
            const siteHeader = document.querySelector('#shopify-section-header .header-wrapper');
            const siteAnnouncement = document.getElementById('shopify-section-announcement-bar');
            let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
              
            let mediaHeight = winHeight - menuList.offsetHeight;
  
            if (siteHeader) {
              mediaHeight -= siteHeader.offsetHeight;
            }
    
            if (siteAnnouncement) {
              mediaHeight -= siteAnnouncement.offsetHeight;
            }
  
            if (mediaHeight >= 180) {
              context.mainMediaDrawer.style.height = mediaHeight + 'px';
              context.mainMediaDrawer.style.minHeight = '0px';
            } else {
              context.mainMediaDrawer.style.height = '0px';
              context.mainMediaDrawer.style.minHeight = '0px';
            }
          } else {
            context.mainMediaDrawer.style.height = '';
            context.mainMediaDrawer.style.minHeight = '';
          }
  
          if (submenus && submenus.length) {
            submenus.forEach((submenu) => {
              submenu.style.paddingBottom = '';
            });
          }
        }
      }, 500);
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    const alwaysOpenedDetails = this.mainDetailsToggle.querySelectorAll('details.keep-open');

    if (alwaysOpenedDetails.length) {
      alwaysOpenedDetails.forEach((detail) => {
        detail.open = true;
      });
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');

      if (this.mainMediaDrawer) {
        let winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (winWidth < 990) {
          // set top menu height
          const menuList = this.querySelector('.menu-drawer__menu');
          const siteHeader = document.querySelector('#shopify-section-header .header-wrapper');
          const siteAnnouncement = document.getElementById('shopify-section-announcement-bar');

          let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
          let mediaHeight = winHeight - menuList.offsetHeight;

          if (siteHeader) {
            mediaHeight -= siteHeader.offsetHeight;
          }

          if (siteAnnouncement) {
            mediaHeight -= siteAnnouncement.offsetHeight;
          }
          
          if (mediaHeight >= 180) {
            this.mainMediaDrawer.style.height = mediaHeight + 'px';
            this.mainMediaDrawer.style.minHeight = '0px';
          } else {
            this.mainMediaDrawer.style.height = '0px';
            this.mainMediaDrawer.style.minHeight = '0px';
          }
        } else {
          this.mainMediaDrawer.style.height = '';
          this.mainMediaDrawer.style.minHeight = '';
        }
      }

      if (this.mainDetailsToggle.parentElement.classList.contains('menu-type--type_2')) {
        const openedSubmenus = this.mainDetailsToggle.querySelectorAll('details[open].keep-open > .menu-drawer__submenu');

        if (openedSubmenus.length) {
          openedSubmenus.forEach((submenu) => {
            submenu.style.setProperty('height', submenu.offsetHeight +'px');
          });
        }
      }
    }, 100);

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }

  onResize(event) {
    super.onResize(event);

    if (this.mainDetailsToggle.hasAttribute('open') && this.mainDetailsToggle.parentElement.classList.contains('menu-type--type_2')) {
      event.preventDefault();
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.querySelector('.product-media-modal__content').addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define('modal-dialog', ModalDialog);


class ModalOpener extends HTMLElement {
  constructor() {
    super();

    let opener = this.querySelector('button');

    if (!opener) {
      opener = this.querySelector('.media');
    };

    if (!opener) {
      return;
    };

    opener.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(opener);
    });
  }
}

customElements.define('modal-opener', ModalOpener);


class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);


class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderLinks = this.querySelectorAll('[id^="Slide-"] a');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dragging = false;
    this.dragTimeout = null;
    this.dragPosInitial = 0;
    this.dragPosFinal = 0;
    this.dragThreshold = 50;

    if (!this.slider || !this.nextButton) return;

    this.initPages();

    const resizeObserver = new ResizeObserver(entries => this.initPages());

    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.slider.addEventListener('mousedown', this.dragStart.bind(this));
    
    this.handleLinks();
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;

    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    this.sliderItems.forEach(item => {
      if (this.isSlideVisible(item) && !item.classList.contains('active')) {
        item.classList.add('active');
      } else if (!this.isSlideVisible(item) && item.classList.contains('active')) {
        item.classList.remove('active');
      }
    });

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && (this.slider.scrollLeft === 0 || this.sliderItemsToShow[0] === this.sliderItems[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;

    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;

    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  dragStart(event) {
    event = event || window.event;

    if (event.type != 'touchstart') {
      event.preventDefault();
      clearTimeout(this.dragTimeout);

      this.dragging = false;
      this.dragPosInitial = this.dragPosX1 = event.clientX;

      document.onmousemove = this.dragAction.bind(this);
      document.onmouseup = this.dragEnd.bind(this);
    }
  }

  dragAction (event) {
    this.dragging = true;
  }

  dragEnd (event) {
    event = event || window.event;
    event.preventDefault();

    this.dragPosFinal = event.clientX;

    const moveLength = Math.abs(this.dragPosFinal - this.dragPosInitial);
    const slidesToMove = Math.round(moveLength / this.sliderItemOffset);

    if ((moveLength >= this.dragThreshold) && slidesToMove) {
      for(let i = 0; i < slidesToMove; i++) {
        if (this.dragPosFinal < this.dragPosInitial) {
          this.nextButton.dispatchEvent(new Event('click'));
        } else if (this.dragPosFinal > this.dragPosInitial) {
          this.prevButton.dispatchEvent(new Event('click'));
        }
      }
    }

    document.onmouseup = null;

    let _this = this;

    this.dragTimeout = setTimeout(() => {
      _this.dragging = false;
    }, 300);
  }

  handleLinks() {
    if (!this.sliderLinks || !this.sliderLinks.length) {
      return;
    }

    let _this = this;

    this.sliderLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (_this.dragging) {
          event.stopImmediatePropagation();
          event.preventDefault();
        }
      });
    });
  }
}

customElements.define('slider-component', SliderComponent);


class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  // linkToSlide(event) {
  //   event.preventDefault();
  //   const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
  //   this.slider.scrollTo({
  //     left: slideScrollPosition
  //   });
  // }
}

customElements.define('slideshow-component', SlideshowComponent);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    const variantChanged = new Event('productvariantchanged', {bubbles: true});
    document.dispatchEvent(variantChanged);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);

    if (mediaGallery) {
      const mediaGalleryViewer = mediaGallery.querySelector(`[id^="GalleryViewer"]`);
      const mediaGalleryThumbnails = mediaGallery.querySelector(`[id^="GalleryThumbnails"]`);

      if (mediaGalleryViewer) {
        const allSecondaryMedias = mediaGalleryViewer.querySelectorAll('[data-media-is-secondary-for]');

        if (allSecondaryMedias.length) {
          let activeSecondaryMedias = [];

          allSecondaryMedias.forEach((element) => {
            element.classList.remove('is-secondary');

            let variants = element.dataset.mediaIsSecondaryFor.split(',');

            if (variants.length) {
              variants.forEach((variantId) => {
                if (variantId == this.currentVariant.id) {
                  activeSecondaryMedias.push(element);
                  
                  return;
                }
              });
            }
          });

          if (activeSecondaryMedias.length) {
            activeSecondaryMedias.forEach((element) => {
              element.classList.add('is-secondary');
            });
          }
        }
      }

      /*if (mediaGalleryThumbnails) {
        const allSecondaryThumbnails = mediaGalleryThumbnails.querySelectorAll('[data-target-is-secondary-for]');
        
        if (allSecondaryThumbnails.length) {
          let activeSecondaryThumbnails = [];

          allSecondaryThumbnails.forEach((element) => {
            element.classList.remove('is-secondary');

            let variants = element.dataset.targetIsSecondaryFor.split(',');

            if (variants.length) {
              variants.forEach((variantId) => {
                if (variantId == this.currentVariant.id) {
                  activeSecondaryThumbnails.push(element);
                  
                  return;
                }
              });
            }
          });

          if (activeSecondaryThumbnails.length) {
            activeSecondaryThumbnails.forEach((element) => {
              element.classList.add('is-secondary');
            });
          }
        }
      }*/

      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

      if (mediaGalleryThumbnails && mediaGalleryViewer) {
        const allThumbnails = mediaGalleryThumbnails.querySelectorAll('.thumbnail-list__item');

        if (allThumbnails.length) {
          allThumbnails.forEach((element) => {
            element.classList.remove('is-active');
            element.classList.remove('is-secondary');

            let target = mediaGalleryViewer.querySelector(`[data-media-id="${element.dataset.target}"]`);

            if (target.classList.contains('is-active')) {
              element.classList.add('is-active');
            }

            if (target.classList.contains('is-secondary')) {
              element.classList.add('is-secondary');
            }
          });
        }
      }
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;

    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');

    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);

    if (!addButton) return;

    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


(function () {
  var links = document.links;
  
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
})();